<template>
  <div class="hello">
    <div class="helloTop">
     <div class="UpOne">300+ 合作伙伴选择我们完成了数字化升级</div>
     <div class="UpTwo">排名不分先后顺序</div>
     
     <div class="image-container">
      <img src="../assets/shouye/4.png" alt="image" class="img1">
      <img src="../assets/shouye/4.png" alt="image" class="img2">
     </div>
     <div class="image-container">
      <img src="../assets/shouye/5.png" alt="image" class="img3">
      <img src="../assets/shouye/5.png" alt="image" class="img4">
     </div>
     <div class="image-container2">
      <img src="../assets/shouye/6.png" alt="image" class="img5">
      <img src="../assets/shouye/6.png" alt="image" class="img6">
     </div>
    <!-- <div class="UpYop">
        <div v-for="(item,i) in items" :key="i" class="UpYouTwo">
            <div class="UpBoss">{{ item.age }}</div>
            <div class="UpYou">{{ item.components }}</div>
        </div>
    </div> -->
    <!-- <div class="con1">
      <div>现在完成注册 即可获取30天免费试用 !</div>
    </div>    -->

    </div>

  </div>
</template>

<script>
export default {
  name: "Upgrade",
  data(){
    return{
        items:[
            {age:'10+',components:'行业领域'},
            {age:'300+',components:'合作伙伴'},
            {age:'1000万+',components:'终端学员'},
        ]
    }
  }
}
</script>

<style lang="scss" scoped>
.image-container {  
  position: relative;
  width: 1227px;
  height: 150px;
  overflow: hidden;
}  
  
.image-container .img1 {  
  height: 120px;
  object-fit: cover;  
  position: absolute;  
  animation: run1 30s linear infinite;  
}  
  
@keyframes run1 {  
  0% {  
    left: 0; 
  }   
  100% {  
    left: -100%;
  } 
}
.image-container .img2 {  
  height: 120px;
  object-fit: cover;  
  position: absolute;  
  animation: run2 30s linear infinite;  
}  
  
@keyframes run2 {  
  0% {  
    left: 100%; 
  }   
  100% {  
    left: 0;
  } 
}

.image-container2 {  
  position: relative;
    width: 1216px;
    margin: 0 0 40px;
    height: 150px;
    overflow: hidden;
} 

.image-container2 .img5 {  
  height: 120px;
  object-fit: cover;  
  position: absolute;  
  animation: run1 30s linear infinite;  
}  
  
@keyframes run1 {  
  0% {  
    left: 0; 
  }   
  100% {  
    left: -100%;
  } 
}
.image-container2 .img6 {  
  height: 120px;
  object-fit: cover;  
  position: absolute;  
  animation: run2 30s linear infinite;  
}  
  
@keyframes run2 {  
  0% {  
    left: 100%; 
  }   
  100% {  
    left: 0;
  } 
}

.image-container .img3 {  
  height: 120px;
  object-fit: cover;  
  position: absolute;  
  animation: run3 30s linear infinite;  
}  
  
@keyframes run3 {  
  0% {  
    left: 0; 
  }   
  100% {  
    left: 100%;
  } 
}
.image-container .img4 {  
  height: 120px;
  object-fit: cover;  
  position: absolute;  
  animation: run4 30s linear infinite;  
}  
  
@keyframes run4 {  
  0% {  
    left: -100%; 
  }   
  100% {  
    left: 0;
  } 
}

.hello {
  width: 100%;
  display: flex;
  justify-content: center;
  // background: linear-gradient(90deg, #f7f8fc 0, #ebf8fe 100%);
  .helloTop {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

.UpOne{
    margin: 57px 0 8px;
    height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #121221;
    line-height: 47px;
}
.UpTwo{
    margin-bottom: 70px;
    height: 34px;
    font-size: 24px;
    font-weight: 500;
    color: #121221;
    line-height: 28px;
}
// .img{
//     width: 100%;
//     margin-bottom: 80px;
//     transform: scale(1);
//     transition: all 0.3s ease;

// }
// .img:hover{
//   transform: scale(1.1);
// }
















.UpYop{
    width: 100%;
display: flex;
background: #ffffff;
height: 239px;
margin-bottom:39px;
   .UpYouTwo{
    width: 400px;
    height: 100%;
    display: flex;
   flex-direction: column;
    align-items: center;
    justify-content: center;
    .UpBoss{
    height: 67px;
font-size: 48px;
font-weight: bold;
color: #EB5B05;
line-height: 67px; 
margin-bottom: 24px;
   }
   .UpYou{
    height: 28px;
font-size: 20px;
font-weight: 500;
color: #121221;
line-height: 28px;
   }
   }
}
  }
}
</style>
